import React from 'react'
import { Box, BoxProps } from '@sitewerk/juraholzbau-design-system'

export const Container: React.FC<BoxProps> = props => (
  <Box width={1} maxWidth="80rem" m="0 auto" {...props} />
)
